var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "c-widget_menu",
        !_vm.$attrs.isFixedMenu ? "is-narrow_widget_menu" : "",
      ],
    },
    _vm._l(_vm.data.children, function (item, index) {
      return _c(
        "div",
        {
          key: index,
          class: [
            "c-widget_menu__item",
            !_vm.$attrs.isFixedMenu ? "is-narrow_item" : "",
            item.meta.isShowSecondaryMenu ? "is-multiple" : "",
          ],
        },
        [
          item.meta.isShowSecondaryMenu
            ? [
                _c(
                  "CMenuGroupItem",
                  _vm._g(
                    _vm._b(
                      { attrs: { data: item } },
                      "CMenuGroupItem",
                      _vm.$attrs,
                      false
                    ),
                    _vm.$listeners
                  )
                ),
              ]
            : [
                _c(
                  "CMenuItem",
                  _vm._b(
                    {
                      class: ["cmenu_item_wrap", _vm.formatActiveRoute(item)],
                      attrs: {
                        data: item,
                        isUseCustomStr: _vm.$attrs.isFixedMenu,
                        customStr: item.meta.title,
                        isDisabled: true,
                      },
                      nativeOn: {
                        mousemove: function ($event) {
                          $event.stopPropagation()
                          return _vm.onMousemove.apply(null, arguments)
                        },
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onRouter(item)
                        },
                      },
                    },
                    "CMenuItem",
                    _vm.$attrs,
                    false
                  ),
                  [
                    _c(
                      "div",
                      {
                        staticClass: "icon_wrap",
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: require("@/components/aiChat/images/svg/xinjianduihuaIcon.svg"),
                          },
                        }),
                      ]
                    ),
                    _c(
                      "template",
                      { slot: "title" },
                      [
                        _c(
                          "Tooltip",
                          _vm._b(
                            {
                              staticClass: "label",
                              attrs: {
                                data: item.meta,
                                disabled: true,
                                keyName: _vm.$attrs.isFixedMenu
                                  ? "title"
                                  : "packName",
                              },
                            },
                            "Tooltip",
                            _vm.$attrs,
                            false
                          )
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }